import React from 'react';
export function LogoOptions() {
  return <div className="min-h-screen bg-slate-50 py-16 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-434">
      <div className="max-w-7xl mx-auto" data-id="element-435">
        <div className="text-center mb-16" data-id="element-436">
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4" data-id="element-437">
            Logo Concepts
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-438">
            A collection of CSS and SVG-based logo directions for Swedenmark AI.
            These can be screenshotted or used as a brief for a brand designer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-439">
          {/* Concept 1: The Original (Gradient Square) */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-440">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-441">
              <h3 className="font-semibold text-slate-800" data-id="element-442">1. The Original</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-443">
                Friendly, modern, app-like.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-444">
              <div className="flex items-center gap-4" data-id="element-445">
                <div className="h-12 w-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl flex items-center justify-center shadow-md" data-id="element-446">
                  <span className="text-white text-xl font-bold tracking-tighter" data-id="element-447">
                    AI
                  </span>
                </div>
                <span className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-448">
                  Swedenmark AI
                </span>
              </div>
            </div>
          </div>

          {/* Concept 2: The Monogram */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-449">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-450">
              <h3 className="font-semibold text-slate-800" data-id="element-451">2. The Monogram</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-452">
                Corporate, established, geometric.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-453">
              <div className="flex items-center gap-4" data-id="element-454">
                <div className="relative h-12 w-12 flex items-center justify-center" data-id="element-455">
                  <svg viewBox="0 0 48 48" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-456">
                    <path d="M24 4L4 14V34L24 44L44 34V14L24 4Z" stroke="#0f2546" strokeWidth="4" strokeLinejoin="round" data-id="element-457" />
                    <path d="M24 14L14 19V29L24 34L34 29V19L24 14Z" fill="#3b82f6" data-id="element-458" />
                  </svg>
                </div>
                <div className="flex flex-col" data-id="element-459">
                  <span className="text-xl font-black text-[#0f2546] tracking-tighter uppercase leading-none" data-id="element-460">
                    Swedenmark
                  </span>
                  <span className="text-sm font-bold text-blue-500 tracking-[0.2em] uppercase mt-1" data-id="element-461">
                    AI Systems
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Concept 3: Circuit Node */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-462">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-463">
              <h3 className="font-semibold text-slate-800" data-id="element-464">3. Circuit Node</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-465">
                Technical, connected, automation-focused.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-slate-900" data-id="element-466">
              <div className="flex items-center gap-4" data-id="element-467">
                <div className="h-10 w-10 relative" data-id="element-468">
                  <svg viewBox="0 0 40 40" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-469">
                    <circle cx="20" cy="20" r="18" stroke="#3b82f6" strokeWidth="2" strokeDasharray="4 4" data-id="element-470" />
                    <circle cx="20" cy="10" r="4" fill="#60a5fa" data-id="element-471" />
                    <circle cx="11" cy="26" r="4" fill="#a78bfa" data-id="element-472" />
                    <circle cx="29" cy="26" r="4" fill="#34d399" data-id="element-473" />
                    <path d="M20 14L13 23M20 14L27 23M15 26H25" stroke="white" strokeWidth="2" strokeLinecap="round" data-id="element-474" />
                  </svg>
                </div>
                <span className="text-2xl font-medium text-white tracking-wide" data-id="element-475">
                  Swedenmark<span className="text-blue-400 font-bold" data-id="element-476">.ai</span>
                </span>
              </div>
            </div>
          </div>

          {/* Concept 4: Bold Wordmark */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-477">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-478">
              <h3 className="font-semibold text-slate-800" data-id="element-479">4. Bold Wordmark</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-480">
                Editorial, confident, minimalist.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-481">
              <div className="flex items-baseline" data-id="element-482">
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-483">
                  SWEDENMARK
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500 ml-1" data-id="element-484">
                  AI
                </span>
                <div className="w-2 h-2 rounded-full bg-emerald-500 ml-1 mb-1" data-id="element-485"></div>
              </div>
            </div>
          </div>

          {/* Concept 5: The Shield */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-486">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-487">
              <h3 className="font-semibold text-slate-800" data-id="element-488">5. The Shield</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-489">
                Trustworthy, secure, enterprise-ready.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-490">
              <div className="flex items-center gap-3" data-id="element-491">
                <div className="h-12 w-10 relative" data-id="element-492">
                  <svg viewBox="0 0 40 48" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-493">
                    <path d="M20 2L4 8V22C4 33 11 43 20 46C29 43 36 33 36 22V8L20 2Z" fill="#0f2546" data-id="element-494" />
                    <path d="M20 12L12 26H18V36L28 22H22V12Z" fill="#3b82f6" data-id="element-495" />
                  </svg>
                </div>
                <div className="flex flex-col justify-center" data-id="element-496">
                  <span className="text-xl font-bold text-slate-800 leading-none mb-1" data-id="element-497">
                    Swedenmark
                  </span>
                  <span className="text-[10px] font-semibold text-slate-500 tracking-widest uppercase leading-none" data-id="element-498">
                    Artificial Intelligence
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Concept 6: Minimal Dot */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-499">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-500">
              <h3 className="font-semibold text-slate-800" data-id="element-501">6. Minimal Dot</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-502">
                Abstract, elegant, forward-thinking.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-zinc-50" data-id="element-503">
              <div className="flex items-center gap-3" data-id="element-504">
                <span className="text-2xl font-light text-zinc-800 tracking-widest lowercase" data-id="element-505">
                  swedenmark
                </span>
                <div className="flex items-center" data-id="element-506">
                  <div className="w-6 h-6 rounded-full bg-gradient-to-tr from-violet-600 to-orange-400 opacity-90 mix-blend-multiply" data-id="element-507"></div>
                  <div className="w-6 h-6 rounded-full bg-gradient-to-tr from-blue-500 to-emerald-400 opacity-90 mix-blend-multiply -ml-3" data-id="element-508"></div>
                </div>
                <span className="text-2xl font-semibold text-zinc-900 tracking-tight" data-id="element-509">
                  ai
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}